var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GmapPolyline',{attrs:{"id":"sales-bot-map-polyline","path":_setup.props.path,"options":_setup.routeLineOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }